export const TOP_MAKES_PATH = 'research/global/top-makes';
